<template>
    <ui-modal :title="title" :close="() => { close(); afterClose?afterClose():null; }" ref="modal">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg class="h-6 w-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                     stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
            </div>
        </template>
        <div>
            <ui-form-section>
                <ui-input label="Your Name" name="name"
                          v-model="form.name"
                          class="xl:col-span-12"></ui-input>
                <ui-textarea
                    label="Why are you rejecting this Dayworks Sheet?"
                    autoresize
                    rows="3"
                    field="resize-none"
                    name="content"
                    v-model="form.comment"
                ></ui-textarea>
            </ui-form-section>
        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap"
                               :loading="form.busy || (!form.name || (form.name.length===0)) || (!form.comment || (form.comment.length===0))" @click="form.submit()"
                               v-text="button"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>
import UiInput from "../../../ui/UiInput.vue";
import UiButtonNew from "../../../ui/UiButtonNew.vue";
import UiFormSection from "../../../ui/UiFormSection.vue";

export default {
    components: {UiFormSection, UiButtonNew, UiInput},
    props: {
        handle: Function,
        handle2: Function,
        handle3: Function,
        close: Function,
        afterClose: Function,
        title: '',
        paragraphs: {
            type: Array,
            default: () => [
                'Are you sure you want to proceed?',
            ],
        },
        button: '',
    },
    data() {
        return {
            form: new Form({}, async (form) => {
                await this.handle(form)
                this.close()
            }),
        }
    },
    methods: {},
    mounted() {
    }
}
</script>
